import { Controller } from "@hotwired/stimulus"

// Controller for inline task tag editing (roles and values)
export default class extends Controller {
  static targets = ["display", "editor"]

  toggle() {
    this.displayTarget.classList.add("hidden")
    this.editorTarget.classList.remove("hidden")
  }

  collapse() {
    this.editorTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}
